module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox-6010ec1df8310cc39e54573929838fd4.png";